class NavMain {
	constructor() {
		const toggle = document.querySelector(".nav-main-toggle");
		const menuOverlay = document.querySelector(".nav-main-container");
		const body = document.querySelector("body");

		toggle.addEventListener("click", () => {
			body.classList.toggle("nav-is-opened");
			smoother.paused(!smoother.paused());
		});

		menuOverlay.addEventListener("click", (e) => {
			const nav = e.composedPath().includes(document.querySelector(".nav-main-header"));
			if (nav) {
				return;
			} else {
				body.classList.remove("nav-is-opened");
				smoother.paused(false);
			}
		});

		// Changement du look de la nav au scroll
		const header = document.querySelector(".header-main");
		ScrollTrigger.create({
			start: () => {
				return "top -"+header.offsetHeight;
			},
			endTrigger: "html",
			toggleClass: {
				className: "page-scrolled",
				targets: body
			}
		});
	}
}